var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10167_18717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.667 4.83203V26.832C21.667 29.2937 23.3653 30.6654 25.167 30.6654C26.8337 30.6654 28.667 29.4987 28.667 26.832V4.9987C28.667 2.74203 27.0003 1.33203 25.167 1.33203C23.3337 1.33203 21.667 2.88703 21.667 4.83203Z",
    fill: "#F9AB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16V26.8333C12.5 29.295 14.1983 30.6667 16 30.6667C17.6667 30.6667 19.5 29.5 19.5 26.8333V16.1667C19.5 13.91 17.8333 12.5 16 12.5C14.1667 12.5 12.5 14.055 12.5 16Z",
    fill: "#E37400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8335 30.6641C8.76649 30.6641 10.3335 29.0971 10.3335 27.1641C10.3335 25.2311 8.76649 23.6641 6.8335 23.6641C4.9005 23.6641 3.3335 25.2311 3.3335 27.1641C3.3335 29.0971 4.9005 30.6641 6.8335 30.6641Z",
    fill: "#E37400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10167_18717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/Google-Analytics.30fead78276015980c2fb46c73097305.svg";
export { ForwardRef as ReactComponent };